import type { WakeSettingsKeytype } from '../@types/WaykeSettings';

const settingKeys = {
  DealerUiUri: 'dui',
  CdnHost: 'cdn',
  CdnPrefix: 'prefixcdn',
  WaykeAnalyticsUri: 'wauri',
  IfInsuranceUri: 'isuri',
  IfBrandingUri: 'iburi',
  GoogleApiKey: 'gapikey',
  GoogleTagManagerID: 'gtmid',
  GoogleTagManagerQuery: 'gtmQ',
  FreespeeId: 'fsaid',
  RemoveAccountUri: 'rmAcc',
  GoogleCaptchaKey: 'grckey',
  EcomUri: 'ecuri',
  mediaServiceUri: 'mediaServiceUri',
  partnerSiteUri: 'partnerSiteUri',
};

type Keys = keyof typeof settingKeys;

export const get = (keyName: Keys) => {
  const settingsKey = settingKeys[keyName] as WakeSettingsKeytype;
  if (process.env.SSR) {
    if (settingsKey && (globalThis as any).wstngs) {
      return (globalThis as any).wstngs[settingsKey];
    }
    return null;
  }
  return window?.wstngs?.[settingsKey];
};
